var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "download-white_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h24v24H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#download-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.624L8.225 11.35l1.05-1.1 2.475 2.475v-8.4h1.5v8.4l2.475-2.475 1.05 1.1-4.275 4.275zM6.8 19.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 015 17.7V15h1.5v2.7c0 .067.033.134.1.2.067.067.133.1.2.1h11.4c.067 0 .133-.033.2-.1.067-.066.1-.133.1-.2V15H20v2.7c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H6.8z",
    fill: "#fff"
  }))));
}
export default SvgDownloadWhite;